export default __webpack_public_path__ + "static/media/landing1.8f46d62e.png";